import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getFamilyCartData } from "../../../../Redux/Actions"
import CartIcon from "../../../../Assets/svg/shopping-cart.svg"
import mobileCartStyles from "./MobileCart.module.css"

const MobileCart = () => {
  const dispatch = useDispatch();

  const familyCartDetails = useSelector((state) => state.getFamilyCartDataReducer.familyCartData);
  const [cartLength, setCartLength] = useState(0);
  const [login, setLogin] = useState(false);

  useEffect(() => {
    try {
      const userDetails = JSON.parse(localStorage.getItem("user"));
      const token = userDetails && userDetails?.token;
      // var citySelect = ""
      if (token) {
        setLogin(true);
        if (!familyCartDetails?.length)
          dispatch(getFamilyCartData(token));
      }
    }
    catch {
      //console.log("User Details Not Found")
    }
  }, [dispatch]);

  useEffect(() => {
    // console.log("Family Cart", familyCartDetails);
    let len = 0;
    if (familyCartDetails && Array.isArray(familyCartDetails)) {
      familyCartDetails.forEach((pack) => {
        len += pack?.members.length
      })
      if (len != 0) {
        document.getElementById("mobile-cart-icon").style.marginLeft = "-10px"
      }
    }
    setCartLength(len);
  }, [familyCartDetails]);

  return (
    <div
      className={mobileCartStyles.iconContainer}
      onClick={() => window.location.href = process.env.RAZZLE_APP_BASE_URL + "/cart"}
    >
      <img
        src={CartIcon}
        id="mobile-cart-icon"
        className={mobileCartStyles.cartIcon}
      />
      {/* <Image
        src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/c5d62e58-5bf6-45ba-a1b2-0c6cfe2a482f.svg"
        alt="cart"
        width={20}
        height={18}
        id="mobile-cart-icon"
      /> */}
      {login && cartLength > 0 ? (
        <span className={mobileCartStyles.cart_count}>{cartLength}</span>
      ) : null}
    </div>
  )
}

export default MobileCart;